export default __webpack_public_path__ + "static/media/section3_2_1_cn.03ac149d.png";